import tmpdata from "./RouteLookup2023H.json"


export const RouteLookup=tmpdata
